<script context="module">
  export const SHEET_POSITIONS = {
    CENTER: "center",
    LEFT: "left",
    RIGHT: "right"
  };
  Object.freeze(SHEET_POSITIONS);
</script>

<script>
  import { slide } from "svelte/transition";
  import { isSafari as safari } from "@utils/support";

  export let delay = 0;
  export let fullWidth = false;
  export let hideTitle = false;
  export let position = SHEET_POSITIONS.CENTER;
</script>

<style>
  .sheet {
    background: var(--surface-color);
    border-top: 1px solid var(--primary-color);
    bottom: 0;
    box-sizing: border-box;
    color: var(--on-surface-color);
    height: auto;
    max-height: 100vh;
    max-width: 768px;
    overflow-x: hidden;
    overflow-y: auto;
    padding: 4rem;
    position: fixed;
    transform: translateZ(0);
    width: 100vw;
    z-index: 1;
  }

  .fullWidth {
    max-width: 100vw;
  }

  .left {
    left: 0;
  }

  .center {
    left: 50%;
    transform: translate3d(-50%, 0, 0);
  }

  .right {
    right: 0;
  }

  h3 {
    margin: 0;
  }

  .title {
    color: var(--primary-color);
    margin: 0 0 3rem;
  }

  .body {
    position: relative;
  }
</style>

<div
  class="sheet"
  class:fullWidth
  class:left={position === SHEET_POSITIONS.LEFT}
  class:center={position === SHEET_POSITIONS.CENTER}
  class:right={position === SHEET_POSITIONS.RIGHT}
  class:safari
  transition:slide={{delay}}
>
  {#if $$slots.title && !hideTitle}
    <h3 class:title={$$slots.title}>
      {#if $$slots.title}
        <slot name="title" />
      {/if}
    </h3>
  {/if}
  <div class="body">
    <slot></slot>
  </div>
</div>
